module.exports = __webpack_public_path__ + "img/02.d10c3e00.png";